// Versioned clock rules: absence of v2 keeps existing full-turn clocks intact.
const PRESETS = Object.freeze({ '10+0': 600000, '30+0': 1800000, '12h': 43200000 });
function selectClock(preset) {
  if (!Object.hasOwn(PRESETS, preset)) throw new Error('Invalid total clock');
  return { version: 2, mode: 'total', preset, initialMs: PRESETS[preset] };
}
function isTotal(player) { return player?.clockSpec?.version === 2 && player.clockSpec.mode === 'total'; }
function remaining(player, now = Date.now()) {
  if (!isTotal(player)) return null;
  if (!Number.isFinite(player.clockRemainingMs)) throw new Error('Missing total clock balance');
  return Math.max(0, player.clockRemainingMs - (Number.isFinite(player.clockRunningSince) ? Math.max(0, now - player.clockRunningSince) : 0));
}
function pause(player, now = Date.now()) {
  if (!isTotal(player)) return;
  player.clockRemainingMs = remaining(player, now);
  player.clockRunningSince = null;
}
function resume(player, now = Date.now()) {
  if (!isTotal(player)) return;
  // Phase changes and reconnects must never refill or restart a running clock.
  if (!Number.isFinite(player.clockRunningSince)) {
    player.clockRunningSince = now;
    player.turnStartTime = now;
    player.turnDuration = player.clockRemainingMs;
  }
}
function handoff(player, now = Date.now()) {
  if (!isTotal(player)) return;
  pause(player.opponent, now);
  resume(player, now);
}
function snapshot(player, now = Date.now()) {
  if (!isTotal(player)) return {};
  return { clockSpec: player.clockSpec, clocks: { sampledAt: now,
    mine: { remainingMs: remaining(player, now), running: Number.isFinite(player.clockRunningSince) },
    opponent: { remainingMs: remaining(player.opponent, now), running: Number.isFinite(player.opponent.clockRunningSince) }
  } };
}
function expired(player, now = Date.now()) { return isTotal(player) && Number.isFinite(player.clockRunningSince) && remaining(player, now) <= 0; }
export { PRESETS, selectClock, isTotal, remaining, pause, resume, handoff, snapshot, expired };
